import {
  defaultContainerElement,
} from "../models/defaultElements";
import { elementConstants } from "../../constants/cms/form/element/element.constants";
import { securityHelper } from "../../helpers/securityHelper";
import { arrayHelper } from "../../helpers/arrayHelper";
import { containers } from "../models/containers";
import { content } from "../models/content";
import { contentHelper } from "./contentHelper";
import { sourceTypes } from "../../constants/cms/sourceType";
import { deepClone } from "../../helpers/objectHelper";

export const containerHelper = {
  create,
  sort,
  addTo,
  remove,
  sort,
  move
};



function getNewId(elements) {
  const containers = elements.filter(
    el => el.type === elementConstants.CONTAINER
  );

  if (!containers.length > 0) {
    return 1;
  }

  return containers.length + 1;
}
function getCurrentContainerId(elements) {
  const containers = elements.filter(
    el => el.type === elementConstants.CONTAINER
  );

  if (containers.length < 1) return 1;
  const maxId = Math.max.apply(Math, containers.map(function (o) { return o.id; }))
  return maxId + 1;
}
function create(source, sourceType, id, sortOrder) {
  const config = containers.find(c => c.id === id);

  let eventId = null;
  let langCode = null;
  let elements = null;
  let currentPage = null;
  let formId = null;
  let pageId = null;

  if (sourceType === sourceTypes.FORM) {
    elements = Array.from(source.formElements);
    currentPage = source.currentPage;
    eventId = source.eventId;
    langCode = source.languageCode;
    formId = source.formId;
  }
  if (sourceType === sourceTypes.PAGE) {
    elements = source.pageElements;
    currentPage = source.currentPage;
    eventId = source.eventId;
    langCode = source.languageCode;
    pageId = source.pageId;
  }
  if (sourceType === sourceTypes.TEMPLATE) {
    elements = source;
    eventId = source.eventId;
    langCode = source.languageCode;
    currentPage = 1;
  }
  let newContainerElements = [];
  let prevLength = elements.length;
  let newId = getCurrentContainerId(elements);
  let newContainer = Object.assign({}, defaultContainerElement);
  newContainer.sortOrder = sortOrder;
  newContainer.formId = formId;
  newContainer.eventId = eventId;
  newContainer.parentId = null;
  newContainer.pageId = pageId;
  newContainer.id = newId++;
  newContainer.languageCode = langCode;
  newContainer.contentId = securityHelper.createGuid();
  newContainer.page = currentPage;

  if (source.parentName !== undefined) {
    newContainer.parentName = source.parentName;
  }

  newContainerElements.push(newContainer);

  for (let index = 0; index < config.type.length; index++) {
    let newChild = Object.assign({}, defaultContainerElement);
    newChild.sortOrder = index;
    newChild.formId = formId;
    newChild.eventId = eventId;
    newChild.parentId = newContainer.id;
    newChild.pageId = pageId;
    newChild.id = newId++;
    newChild.languageCode = langCode;
    newChild.contentId = securityHelper.createGuid();
    newChild.page = currentPage;
    newChild.data = {
      ...defaultContainerElement.data,
      style: { width: config.type[index] }
    };
    newContainerElements.push(newChild);
  }
  return newContainerElements;
}

function setSource(source, sourceType, target) {
  const newSrc = Object.assign({}, source);
  if (sourceType === sourceTypes.FORM) {
    newSrc.formElements = target;
  }
  if (sourceType === sourceTypes.PAGE) {
    newSrc.pageElements = target;
  }
  if (sourceType === sourceTypes.TEMPLATE) {
    newSrc.elements = target;
  }
  return newSrc;
}
function getSource(source, sourceType) {
  if (sourceType === sourceTypes.FORM) {
    return Array.from(source.formElements);
  }
  if (sourceType === sourceTypes.PAGE) {
    return Array.from(source.pageElements);
  }
  if (sourceType === sourceTypes.TEMPLATE) {
    return Array.from(source.elements);
  }
}

function remove(form, outerContainer, innerContainer, element) {
  const trimmedInnerContainer = innerContainer.props.elements.filter(
    (el, i) => el.contentId !== element.contentId
  );

  outerContainer.props.elements.map((el, i) => {
    if (el.contentId === innerContainer.contentId) {
      el.props.elements = trimmedInnerContainer;
    }
  });

  return form;
}

function sort(form, result) {
  const newForm = { ...form };
  const { destination, source, draggableId } = result;
  const newFormElements = [...newForm.formElements];
  const targetContainerId = destination.droppableId.slice(
    9,
    destination.droppableId.length
  );

  const targetContainer = newFormElements.find(el => {
    return el.contentId === targetContainerId;
  });

  if (!targetContainer) {
    return;
  }

  const targetContainerChildrens = [
    ...newFormElements.filter(el => {
      return el.page === form.currentPage && el.parentId === targetContainer.id;
    })
  ];

  const newtargetContainerChild = [...targetContainerChildrens];

  const indexDiff = Math.abs(source.index - destination.index);
  let destinationTrack = null;

  if (destination.index > source.index && indexDiff > 1) {
    destinationTrack = targetContainerChildrens.filter(el => {
      return (
        el.sortOrder <= destination.index &&
        el.sortOrder !== newtargetContainerChild[source.index].sortOrder
      );
    });
    for (let index = 0; index < destinationTrack.length; index++) {
      destinationTrack[index].sortOrder = destinationTrack[index].sortOrder - 1;
    }
    targetContainerChildrens[source.index].sortOrder = destination.index;
    arrayHelper.concat(
      newFormElements,
      targetContainerChildrens,
      destinationTrack
    );
  } else if (destination.index < source.index && indexDiff > 1) {
    destinationTrack = targetContainerChildrens.filter(el => {
      return (
        el.sortOrder >= destination.index &&
        el.sortOrder <= source.index &&
        el.sortOrder !== newtargetContainerChild[source.index].sortOrder
      );
    });
    for (let index = 0; index < destinationTrack.length; index++) {
      destinationTrack[index].sortOrder = destinationTrack[index].sortOrder;
    }
    targetContainerChildrens[source.index].sortOrder = destination.index;
    arrayHelper.concat(
      newFormElements,
      targetContainerChildrens,
      destinationTrack
    );
    /*    newForm.formElements = newFormElements;
                   return newForm; */
  } else {
    //if an element just been moved one index
    targetContainerChildrens[source.index].sortOrder = destination.index;
    targetContainerChildrens[destination.index].sortOrder = source.index;
    arrayHelper.concat(newFormElements, targetContainerChildrens);
  }
  /* let arr = newForm.formElements.map(a => a.sortOrder); */
  newForm.formElements = newFormElements;
  return newForm;
}

function move(source, sourceType, result) {
  const { destination, draggableId } = result;

  let newSrc = Object.assign({}, source);
  let target = getSource(source, sourceType);

  const elementToMove = target.find(el => {
    return el.contentId === draggableId;
  });

  if (elementToMove === undefined || elementToMove.type === elementConstants.CONTAINER) {
    return;
  }
  //If the destination is to a container
  if (destination.droppableId.includes("column")) {
    //We know the destination is to a container so we want to know which one
    const containerId = parseInt(destination.droppableId.substring(destination.droppableId.indexOf('-') + 1, destination.droppableId.lastIndexOf('-') + 1));
    //The source where the element used to live [null = Main content, {*numeric*} = containerId]
    const sourceId = elementToMove.parentId;

    elementToMove.parentId = containerId;
    elementToMove.sortOrder = destination.index;

    const container =
      deepClone(target.find(el => {
        return (
          el.type === elementConstants.CONTAINER && el.id === containerId
        );
      })
      );

    if (!container && container === undefined) {
      return;
    }

    if (elementToMove.type === elementConstants.EVENT && container.data.type === 'EVENT_GROUP') {
      elementToMove.data.groupId = containerId;
    }
    //All the elements where the element inherit from, do not include the element it self
    const sourceElements = [
      ...target.filter(el => {
        return (
          el.parentId === sourceId && el.contentId !== elementToMove.contentId
        );
      })
    ];
    //adjust the target location with the new element
    target = adjustTarget(
      destination,
      target,
      containerId,
      elementToMove
    );
    //adjust source location and reorder the elements
    adjustSource(sourceElements);
    //merge the all elements with the source
    arrayHelper.concat(target, sourceElements);
    newSrc = setSource(newSrc, sourceType, target)
  } else {
    const containerId = null;
    const sourceId = elementToMove.parentId;

    if (elementToMove.type === elementConstants.EVENT) {
      elementToMove.data.groupId = null;;
    }

    //the element will be placed outside a container

    //All the elements where the element inherit from, do not include the element it self
    const sourceElements = [
      ...target.filter(el => {
        return (
          el.parentId === elementToMove.parentId &&
          el.contentId !== elementToMove.contentId
        );
      })
    ];

    elementToMove.parentId = null;
    elementToMove.sortOrder = destination.index;
    //adjust the target location with the new element
    target = adjustTarget(
      destination,
      target,
      elementToMove.parentId,
      elementToMove
    );
    //adjust source location and reorder the elements
    adjustSource(sourceElements);
    //merge the all elements with the source
    arrayHelper.concat(target, sourceElements);
    newSrc = setSource(newSrc, sourceType, target)
  }
  return newSrc;
}

function addTo(source, sourceType, elements, result) {
  const { destination, draggableId } = result;
  const elementInfo = draggableId.split(":");
  //Not allowed to drop a container inside a container
  if (parseInt(elementInfo[0]) === elementConstants.CONTAINER) {
    return;
  }
  const containerWrapperId = parseInt(
    destination.droppableId.slice(
      destination.droppableId.indexOf("-") + 1,
      destination.droppableId.lastIndexOf("-")
    )
  );

  let target = null;

  if (sourceType === sourceTypes.FORM) {
    target = source.formElements;
  }
  if (sourceType === sourceTypes.PAGE) {
    target = source.pageElements;
  }
  if (sourceType === sourceTypes.TEMPLATE) {
    target = source;
  }


  //spread the form for insertion
  //Find the element that is about to be moved to a new destination
  let element = elements !== undefined ?
    deepClone(elements.find(el => {
      return (
        el.id === parseInt(elementInfo[1]) &&
        el.type === parseInt(elementInfo[0])
      );
    })) : null;


  //Find the container that will be recieving an element
  const container =
    deepClone(target.find(el => {
      return (
        el.type === elementConstants.CONTAINER && el.id === containerWrapperId
      );
    })
    );

  if (!container && container === undefined) {
    return;
  }
  const parentContainer =
    deepClone(target.find(el => {
      return (
        el.type === elementConstants.CONTAINER && el.id === container.parentId
      );
    })
    );

  if (parseInt(elementInfo[0]) === elementConstants.EVENT && parentContainer && parentContainer.data.type === 'EVENT_GROUP'
    || parseInt(elementInfo[0]) === elementConstants.EVENT && container.parentId === null && container.data.type === 'EVENT_GROUP') {
    element.data.groupId = parentContainer.id;

  }
  if (parseInt(elementInfo[0]) === elementConstants.CONTENT) {
    const selectedEl = content.find((el, index) => {
      return el.id === elementInfo[1];
    });

    element = contentHelper.create(source, sourceType, selectedEl, destination);
    element.parentId = containerWrapperId;
  }

  if (sourceType === sourceTypes.FORM) {
    const newForm = deepClone(source);
    newForm.formElements = adjust(
      element,
      containerWrapperId,
      destination,
      source,
      sourceType
    );

    return newForm;
  }
  if (sourceType === sourceTypes.PAGE) {
    const newPage = deepClone(source);
    newPage.pageElements = adjust(
      element,
      containerWrapperId,
      destination,
      source,
      sourceType
    );
    return newPage;
  }
  if (sourceType === sourceTypes.TEMPLATE) {
    let tempSource = deepClone(source);
    tempSource = adjust(element, containerWrapperId, destination, source, sourceType);
    return tempSource;
  }
}

function adjustSource(sourceElements) {
  sourceElements.sort((a, b) => {
    let x = a.sortOrder;
    let y = b.sortOrder;
    return y < x ? 1 : y > x ? -1 : 0;
  });
  sourceElements.map((el, index) => {
    el.sortOrder = index;
  });
  return sourceElements;
}

function adjustTarget(destination, formElements, parentId, elementToMove) {
  const reArranged = Array.from(formElements);
  let destinationTrack = null;
  destinationTrack = reArranged.filter(el => {
    return (
      el.sortOrder >= destination.index &&
      el.parentId === parentId &&
      el.contentId !== elementToMove.contentId
    );
  });
  for (let index = 0; index < destinationTrack.length; index++) {
    destinationTrack[index].sortOrder = destinationTrack[index].sortOrder + 1;
  }
  arrayHelper.concat(reArranged, destinationTrack);
  return reArranged;
}

function adjust(element, parentId, destination, source, sourceType) {
  let elements = null;
  let eventId = null;
  let langCode = null;
  let currentPage = null;
  let formId = null;
  let pageId = null;

  if (sourceType === sourceTypes.FORM) {
    elements = source.formElements;
    currentPage = source.currentPage;
    eventId = source.eventId;
    langCode = source.languageCode;
    formId = source.formId;
  }
  if (sourceType === sourceTypes.PAGE) {
    elements = source.pageElements;
    currentPage = source.currentPage;
    eventId = source.eventId;
    langCode = source.languageCode;
    pageId = source.pageId;
  }
  if (sourceType === sourceTypes.TEMPLATE) {
    elements = source;
    eventId = source.eventId;
    langCode = source.languageCode;
  }

  let destinationTrack = null;
  destinationTrack = elements.filter(el => {
    return el.sortOrder >= destination.index + 1 && el.parentId === parentId;
  });
  //Filter all the elements with a higher sortOrder than the requested
  //index for the new element
  //Increase all the elements that are above the requested index with 1
  for (let index = 0; index < destinationTrack.length; index++) {
    destinationTrack[index].sortOrder = destinationTrack[index].sortOrder + 1;
  }

  elements.push({
    ...element,
    sortOrder: destination.index,
    formId: formId,
    languageCode: langCode,
    contentId: securityHelper.createGuid(),
    parentId: parentId,
    pageId: pageId,
    page: currentPage,
    eventId: eventId,
  });
  arrayHelper.concat(elements, destinationTrack);
  return elements;
}
